<template>
  <div id="download">
      <div class="image">
          <h3>Enjoy the sweetness of Fast and Affordable Food Delivery service</h3>
      </div>
      <div class="download">
          <img src="../assets/Rectangle.png" alt="Mealtrips Prototype" class="proto">
          <p>Dowload, Enjoy and don’t forget to leave feedbacks on the restaurant and delivery services to help other users decide better too.</p>
          <a href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips" target="_blank"><button class="store"><Icons name="playstore" /> <div class="text">Download the app on <br> <span>Google Play</span></div></button></a>
      </div>
  </div>
</template>

<script>
import Icons from './Icons.vue'

export default {
    name: 'Download',
    components: {
        Icons
    }
}
</script>

<style lang="scss" scoped>
#download{
    width: 100%;
    background: #fff;
    position: relative;
    a:hover{
        text-decoration: none;
    }
    .image{
        position: relative;
        background: url('../assets/food.png');
        height: 100vh;
        background-size: cover;
        color: #fff;
        display: flex;
        justify-content: center;
        h3{
            margin-top: 100px;
            text-align: center;
            font-size: 48px;
            font-weight: 400;
            font-family: 'Abril Fatface', cursive;
            width: 565px;
        }
    }
    .proto{
        position: absolute;
        right: 0px;
        top: 50px;
    }
    .download{
        padding: 48px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p{
            width: 584px;
            font-family: 'Raleway', sans-serif;
            font-weight: 300;
            font-size: 18px;
            text-align: center;
        }
        .store{
            background: #030607;
            font-family: 'Raleway', sans-serif;
            display: flex;
            align-items: center;
            padding: 16px 32px;
            border: none;
            border-radius: 48px;
            margin: auto;
            margin-top: 36px;
            .text{
                color: #fefefe;
                font-size: 14px;
                margin-left: 24px;
                span{
                    font-size: 24px;
                    font-weight: bold;
                }
            }
        }
    }
}

@media (max-width: 480px) {
    #download{
    width: 100%;
    background: #fff;
    position: relative;
    .image{
        position: relative;
        background: url('../assets/food.png');
        height: 60vh;
        background-size: cover;
        background-position: center;
        color: #fff;
        display: flex;
        justify-content: center;
        // align-items: center;
        h3{
            margin-top: 35%;
            text-align: center;
            font-size: 24px;
            font-weight: 400;
            font-family: 'Abril Fatface', cursive;
            width: 80%;
        }
    }
    .proto{
        display: none;
        position: absolute;
        right: 0px;
        top: 50px;
    }
    .download{
        padding: 48px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p{
            width: 80%;
            font-family: 'Raleway', sans-serif;
            font-weight: 300;
            font-size: 16px;
            text-align: center;
        }
        .store{
            background: #030607;
            font-family: 'Raleway', sans-serif;
            display: flex;
            align-items: center;
            padding: 8px 16px;
            border: none;
            border-radius: 48px;
            margin: auto;
            margin-top: 36px;
            .text{
                color: #fefefe;
                font-size: 12px;
                margin-left: 14px;
                span{
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }
    }
}
}

@media (min-width: 481px) and (max-width: 768px) {
    #download{
    width: 100%;
    background: #fff;
    position: relative;
    .image{
        position: relative;
        background: url('../assets/food.png');
        height: 60vh;
        background-size: cover;
        background-position: center;
        color: #fff;
        display: flex;
        justify-content: center;
        // align-items: center;
        h3{
            margin-top: 30%;
            text-align: center;
            font-size: 28px;
            font-weight: 400;
            font-family: 'Abril Fatface', cursive;
            width: 80%;
        }
    }
    .proto{
        display: none;
        position: absolute;
        right: 0px;
        top: 50px;
    }
    .download{
        padding: 48px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p{
            width: 80%;
            font-family: 'Raleway', sans-serif;
            font-weight: 300;
            font-size: 16px;
            text-align: center;
        }
        .store{
            background: #030607;
            font-family: 'Raleway', sans-serif;
            display: flex;
            align-items: center;
            padding: 8px 16px;
            border: none;
            border-radius: 48px;
            margin: auto;
            margin-top: 36px;
            .text{
                color: #fefefe;
                font-size: 12px;
                margin-left: 14px;
                span{
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }
    }
}
}

@media (min-width: 769px) and (max-width: 1024px) {
    #download{
    width: 100%;
    background: #fff;
    position: relative;
    .image{
        position: relative;
        background: url('../assets/food.png');
        height: 60vh;
        background-size: cover;
        background-position: center;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        h3{
            margin-top: 0;
            text-align: center;
            font-weight: 400;
            font-family: 'Abril Fatface', cursive;
            width: 80%;
        }
    }
    .proto{
        display: none;
        position: absolute;
        right: 0px;
        top: 10%;
        width: 300px;
        height: 400px;
    }
    .download{
        padding: 50px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p{
            width: 80%;
            font-family: 'Raleway', sans-serif;
            font-weight: 300;
            text-align: center;
        }
        .store{
            background: #030607;
            font-family: 'Raleway', sans-serif;
            display: flex;
            align-items: center;
            padding: 10px 18px;
            border: none;
            border-radius: 48px;
            margin: auto;
            margin-top: 36px;
            .text{
                color: #fefefe;
                font-size: 14px;
                margin-left: 14px;
                span{
                    font-weight: bold;
                }
            }
        }
    }
}
}
</style>